import { render, staticRenderFns } from "./KanfangShareCode.vue?vue&type=template&id=68c15c41&scoped=true&"
import script from "./KanfangShareCode.vue?vue&type=script&lang=js&"
export * from "./KanfangShareCode.vue?vue&type=script&lang=js&"
import style0 from "./KanfangShareCode.vue?vue&type=style&index=0&id=68c15c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c15c41",
  null
  
)

export default component.exports